import { parseCalendarDate } from './helper';

// Mission dates are calendar days, not instants: the API stores duration.dateend as a
// string serialised at UTC midnight, while the DatePicker hands back a local Date carrying
// the current time of day. Comparing the two raw makes an interruption on the mission's
// own last day look "after the end" from 02:00 local onwards, so every comparison here
// runs on local midnights.
const startOfDay = (date) => {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
};

export const formatDateFr = (date) => {
  if (!date) return '…';
  const d = date instanceof Date ? date : parseCalendarDate(date);
  return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
};

const missionEndDay = (missionDateEnd) =>
  missionDateEnd ? startOfDay(parseCalendarDate(missionDateEnd)) : null;

export const getInterruptEndDateError = ({
  endDate,
  missionDateEnd,
  isNoShow = false,
  today = new Date(),
}) => {
  // A No-Show cancels or unassigns the mission outright, no end date is applied.
  if (isNoShow) return '';
  if (!endDate) return '';

  const selected = startOfDay(endDate);
  if (selected < startOfDay(today))
    return "La date d'interruption ne peut pas être antérieure à aujourd'hui";

  const end = missionEndDay(missionDateEnd);
  if (end && selected > end)
    return `La date d'interruption ne peut pas dépasser la date de fin prévue (${formatDateFr(end)})`;

  return '';
};

export const getReplacementRange = ({ endDate, missionDateEnd }) => {
  const end = missionEndDay(missionDateEnd);
  const start = startOfDay(endDate);
  start.setDate(start.getDate() + 1);

  // Interrupting on the mission's last day leaves no following day to staff: the
  // replacement covers that same day rather than an inverted range the back would
  // duplicate as is.
  return { start: end && start > end ? new Date(end) : start, end };
};

// Whether an interruption falls within the trial period, its last day included.
// A mission whose trial period is unknown is taken as past it: a trial ending is
// never offered on a guess.
export const isWithinTrialPeriod = ({ endDate, trialPeriodEnd }) => {
  if (!endDate || !trialPeriodEnd) return false;
  return startOfDay(endDate) <= startOfDay(parseCalendarDate(trialPeriodEnd));
};
